import { render, staticRenderFns } from "./BattleInvitations.vue?vue&type=template&id=354ef93b&scoped=true"
import script from "./BattleInvitations.vue?vue&type=script&lang=js"
export * from "./BattleInvitations.vue?vue&type=script&lang=js"
import style0 from "./BattleInvitations.vue?vue&type=style&index=0&id=354ef93b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354ef93b",
  null
  
)

export default component.exports